export const formatPhoneNumber = (value: string) => {
  const clearedPhone = value.replace(/(^\+?7)|\D/g, '');

  return `+7${clearedPhone}`.replace(/^\+7(\d{3})(\d{3})(\d\d)(\d\d).*/, '+7 $1 $2-$3-$4');
};
